export default __webpack_public_path__ + "static/media/A_wdt_c_cap_2.7e733f47.mp3";